import { API_URL, questionsLoader } from "./QuestionsLoader";
import { PageQuery } from "./typings";
import { stringifyUrl } from "query-string";

export class TexHelpersApi {
	public static getTexHelpers(query: PageQuery = {}) {
		const url = stringifyUrl({ url: "/tex_helpers", query }, { arrayFormat: "comma" });
		return questionsLoader.get({
			baseURL: API_URL,
			url,
		});
	}
}
